import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import MemeGenerator from '../../components/MemeGenerator';

const MemePage: React.FC = () => (
  <ToolLayout
    title="Meme Generator - Create Memes Online Free | AllTools"
    description="Create memes with custom text. Impact font, text outlines, top and bottom captions. Free meme maker."
    canonicalPath="/meme-generator"
  >
    <MemeGenerator />
  </ToolLayout>
);

export default MemePage;
